module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro4.e9fc95ef.pdf";